import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../auth/services/auth.service';

interface NavItem {
  label: string;
  route: string;
  roles: string[];
}

@Component({
  selector: 'app-sidebar',
  standalone: false,
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss'
})
export class SidebarComponent {
  @Output() closeSidebar = new EventEmitter<void>();
  @Input() isSidebarOpened = false;

  userRole: string | null = null;
  navItems: NavItem[] = [
    { label: 'Orders', route: '/dashboard/orders', roles: ['SUPER_ADMIN', 'ADMIN']},
    { label: 'Products', route: '/dashboard/products', roles: ['SUPER_ADMIN', 'SALESPERSON', 'ADMIN'] },
    { label: 'Users', route: '/dashboard/users', roles: ['SUPER_ADMIN', 'SALESPERSON', 'ADMIN'] },
    { label: 'Categories', route: '/dashboard/categories', roles: ['SUPER_ADMIN', 'ADMIN'] },
    { label: 'Brands', route: '/dashboard/brands', roles: ['SUPER_ADMIN'] },
    //{ label: 'Recorded Sales', route: '/dashboard/sales', roles: ['SUPER_ADMIN', 'SALESPERSON', 'ADMIN'] },
    { label: 'Support Requests', route: '/dashboard/requested-services', roles: ['SUPER_ADMIN', 'SALESPERSON', 'ADMIN'] },
    { label: 'Reports', route: '/dashboard/reports', roles: ['SUPER_ADMIN', 'ADMIN'] },
    { label: 'Static Pages', route: '/dashboard/static-pages', roles: ['SUPER_ADMIN', 'ADMIN'] },
    { label: 'Sliders', route: '/dashboard/sliders', roles: ['SUPER_ADMIN', 'ADMIN'] },
    { label: 'Logout', route: '/logout', roles: ['SUPER_ADMIN', 'SALESPERSON', 'ADMIN'] }
  ];

  constructor(private readonly router: Router, private readonly authService: AuthService) {
    this.userRole = this.authService.getUserRole();
  }

  get filteredNavItems(): NavItem[] {
    return this.navItems.filter(item => item.roles.includes(this.userRole ?? ''));
  }
  
  navigate(path: string): void {
    this.router.navigate([path]);
  }

  onCloseSidebar() {
    this.closeSidebar.emit();
  }

  onLogout(): void {
    this.authService.logout();
  }
}
